import { ResourceOptions } from 'react-admin';
import { FaUniversity } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingRedpacketPlatformLedger;
export const icon = FaUniversity;
export const options: ResourceOptions = {
  label: 'module.socialTrading.redpacketPlatformLedger',
};
